<template>
  <div class="page-effect">
    <div
      class="
        container-fluid
        border-bottom
        p-0
        ss-reg-top
        d-md-flex
        justify-content-end
        page-option-sticky
        sticky-without-menu
      "
    >
      <a
        href="#"
        class="pt-3 left-effect2"
        data-toggle="modal"
        data-target="#CheckoutformypeModal"
        @click="openBulkUploadPopup()"
      >
        <img
          src="../assets/Images/self-service/manage-category.svg"
          class="mr-1"
          style="width: 15px"
        />
        Manage Categories</a
      >

      <a
        id="v-step-com"
        href="#"
        class="pt-3 left-effect2"
        data-toggle="modal"
        data-target="#RegistrationtypeModal"
        ><v-icon color="#5f6368" size="18px" class="mr-1"
          >mdi-cog-outline</v-icon
        >
        Advanced Settings</a
      >

      <v-btn
        class="my-2 mr-4 save-standard"
        outlined
        color="#2376e5"
        width="180px"
        @click="AddExpoBoothPopup()"
        ><v-icon id="v-step-0" class="mr-1" color="#2376e5" size="20px"
          >mdi-plus</v-icon
        >
        Add New Exhibitor</v-btn
      >
    </div>
    <div class="admin-expo-page-wrap">
      <h3>Setup Expo</h3>

      <div class="blank-expo-section" v-if="allExhibitorsList.length == 0">
        <img src="../assets/Images/self-service/exhibitor.png" />
        <h3 class="mt-3">Create an expo</h3>
        <p class="mt-3">
          The Expo area is the exhibitor hall of digital vendor booths at your
          event. You can choose from 3 different types of Expo Halls and from
          more that 12+ booth design templates so that attendees can visit the
          booths that interest them, network and take action.
        </p>
        <v-btn
          dark
          color="#1a73e8"
          class="save-standard mt-3"
          @click="AddExpoBoothPopup()"
          ><v-icon size="20px" color="#ffffff">mdi-plus</v-icon> Add New
          exhibitor</v-btn
        >
      </div>

      <div class="admin-expohall-wrap" v-else>
        <div
          class="admin-single-expohall"
          v-for="exhibitor in allExhibitorsList"
          v-bind:key="exhibitor.ExhibitorId"
        >
          <div class="expohall-row-left">
            <div class="single-booth-img-left" v-if="exhibitor.HotspotImageURL">
              <img :src="exhibitor.HotspotImageURL" />
            </div>
            <div class="single-booth-img-left" v-else>
              <img
                src="../assets/Images/reg-ico/img-icon.svg"
                title="image"
                width="64px"
              />
            </div>

            <div class="booth-name-email">
              <h4>{{ exhibitor.Name }}</h4>
              <a href="#">{{ exhibitor.Email }}</a>
            </div>
          </div>
          <div class="expohall-row-center">
            <p>{{ exhibitor.BoothNo }}</p>
            <p>{{ exhibitor.Category }}</p>
          </div>
          <div class="expohall-row-right">
            <v-btn icon
              ><v-icon
                size="25px"
                color="#7f818b"
               @click="toExpoList(exhibitor.ExhibitorId)"
                >mdi-pencil-outline</v-icon
              ></v-btn
            >
            <v-btn icon
              ><v-icon size="25px" color="#7f818b"
                >mdi-trash-can-outline</v-icon
              ></v-btn
            >
          </div>
        </div>
      </div>
    </div>

    <!--add expo popup-->
    <v-dialog v-model="ExpoBoothAdd" max-width="1024" scrollable>
      <v-card class="addboothModal">
        <v-card-title>
          <div class="add-ex-booth-modal-top">
            <h3>Add a new Exhibitor</h3>
            <div style="position: absolute; right: 15px; top: 15px">
              <v-icon style="z-index: 2" size="32" @click="ExpoBoothAdd = null"
                >close</v-icon
              >
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="cusom-wizard-wrap">
            <v-stepper v-model="e6" vertical>
              <div class="d-flex justify-content-start align-items-start">
                <div
                  class="
                    d-flex
                    justify-content-start
                    align-items-start
                    flex-column
                    stepper-wrap
                  "
                >
                  <v-stepper-step :complete="e6 > 1" step="1" color="#000">
                    <p class="stepper-text mb-0"><b>Booth Details</b></p>
                  </v-stepper-step>
                  <v-stepper-step :complete="e6 > 2" step="2" color="#000">
                    <p class="stepper-text mb-0"><b>Setup Booth</b></p>
                  </v-stepper-step>
                </div>
                <div
                  class="
                    d-flex
                    justify-content-start
                    align-items-start
                    flex-column
                    stepper-content-wrap
                  "
                >
                  <v-stepper-content step="1">
                    <div class="create-booth-form">
                      <h4 class="pb-2">Booth Details</h4>
                      <p>
                        About setup booth. Lorem Ipsum is simply dummy text of
                        the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the
                        1500s, when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                      </p>
                      <v-row class="my-0">
                        <v-col cols="12" md="6">
                          <div class="crete-booth-field">
                            <label>Exhibitor Name*</label>
                            <input
                              type="text"
                              name="expoName"
                              id=""
                              v-model="expoName"
                            />
                            <label>Phone No</label>
                            <input
                              type="text"
                              name=""
                              id=""
                              v-model="expoPhoneNo"
                            />
                            <label>Booth No</label>
                            <input
                              type="text"
                              name=""
                              id=""
                              v-model="expoBoothNo"
                            />
                            <label
                              >Email
                              <v-icon color="#b4b4b4" size="20px"
                                >mdi-information-outline</v-icon
                              ></label
                            >
                            <input
                              type="email"
                              name=""
                              id=""
                              v-model="expoEmail"
                            />
                            <label>Website</label>
                            <input
                              type="url"
                              name=""
                              id=""
                              v-model="expoWebsite"
                            />
                            <label
                              >Showcase Video Link(Youtube or Vimeo)
                              <v-icon color="#b4b4b4" size="20px"
                                >mdi-information-outline</v-icon
                              ></label
                            >
                            <input
                              type="url"
                              name=""
                              id=""
                              v-model="expoShowcaseVideo"
                            />
                          </div>
                        </v-col>

                        <v-col cols="12" md="6">
                          <div class="drag_n_drop">
                            <img
                              src="../assets/Images/reg-ico/img-icon.svg"
                              class="mb-4"
                            />
                            <input type="file" name="" id="" />
                            <h5>
                              Drag &amp; drop or click to add exhibitor logo
                            </h5>
                            <p>
                              Logo should be in the ratio of 2:1 in transparent
                              PNG format
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <div class="create-booth-form">
                      <h4 class="pb-2">Booth Details</h4>
                      <p>
                        About setup booth. Lorem Ipsum is simply dummy text of
                        the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the
                        1500s, when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                      </p>

                      <v-row class="my-0">
                        <v-col cols="12" md="6">
                          <div class="hotspot-category">
                            <label>Category*</label>
                            <v-select
                              :items="items2"
                              outlined
                              color="#000"
                              label="Select category"
                              height="50px"
                              v-model="expoCategory"
                            ></v-select>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="my-0 pt-0">
                        <v-col cols="12" md="6" class="mt-0 pt-0">
                          <div class="hotspot-image-upload">
                            <label
                              >Upload Hotspot Image
                              <v-icon color="#b4b4b4" size="20px"
                                >mdi-information-outline</v-icon
                              ></label
                            >
                            <div
                              class="
                                d-flex
                                justify-content-start
                                align-items-center
                              "
                            >
                              <input
                                type="text"
                                name=""
                                id=""
                                v-model="expoHotspotImg"
                                class="mr-2"
                              />
                              <label class="upload-butn">
                                <input type="File" name="" id="" value="" />
                                Upload
                              </label>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="mt-0 pt-0">
                          <div class="download-psd">
                            <button>
                              <img src="../assets/Images/psd-ico.png" />
                              Download PSD
                            </button>
                          </div>
                        </v-col>
                        <v-col cols="12" md="12">
                          <div class="event-booth-hotspot-image-wrap">
                            <img src="../assets/Images/booth7.png" />
                          </div>
                        </v-col>
                        <hr />
                        <v-col cols="12" md="12">
                          <div class="hotspot-category">
                            <label>Mapped Contacts</label>
                            <v-select
                              :items="items2"
                              outlined
                              color="#000"
                              label="Select contact"
                              height="50px"
                              v-model="expoMappedContact"
                            ></v-select>
                          </div>
                        </v-col>
                        <v-col cols="12" md="12">
                          <div class="hotspot-category">
                            <label>Profile(Optional)</label>
                            <textarea
                              cols="12"
                              rows="12"
                              v-model="expoProfile"
                            ></textarea>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-stepper-content>
                </div>
              </div>
            </v-stepper>
          </div>
        </v-card-text>
        <v-divider class="m-0"></v-divider>
        <v-card-actions>
          <div
            class="d-flex my-5 full-width align-items-end justify-content-end"
          >
            <v-btn
              class="mr-2"
              outlined
              large
              color="#959595"
              width="122px"
              @click="e6 = 1"
              >Cancel</v-btn
            >
            <v-btn
              large
              dark
              color="#1973e7"
              @click="expoFormSubmit()"
              width="122px"
              >Save & Next</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--add expo end-->
  </div>
</template>
<script>
import axios from "axios";
import APIs from "@/components/APIInit";
import { bus } from "@/main";
import router from "../router";
export default {
  components: {},
  data() {
    return {
      allExhibitorsList: [],
      ExpoBoothAdd: false,
      e6: 1,
      expoName: "",
      expoPhoneNo: "",
      expoBoothNo: "",
      expoEmail: "",
      expoWebsite: "",
      expoCategory: "",
      expoMappedContact: [],
      expoProfile: "",
      expoShowcaseVideo: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.fetchExhibitorsList();
  },
  methods: {
    fetchExhibitorsList() {
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: this.$store.state.client[0].id,
        eventId: this.$store.state.eventid,
      };

      axios
        .get(APIs.ExhibitorSelfServiceFetchApi, { headers: headers })
        .then((response) => {
          console.log("response====", response);
          this.allExhibitorsList = response.data.results;
        });
    },
    AddExpoBoothPopup() {
      /* this.expoName="",
     this.expoPhoneNo="",
      this.expoBoothNo="",
      this.expoEmail="",
      this.expoWebsite="",
      this.expoCategory="",
      this.expoMappedContact="",
      this.expoProfile="",
      this.expoShowcaseVideo="",
      this.ExpoBoothAdd=true;*/
      router.push({ name: "ExpoViewAddEdit" });
    },
    expoFormSubmit() {
      bus.$emit("toggleLoader", true);
      console.log("expoName", this.expoName);
      console.log("expo Ph", this.expoPhoneNo);
      console.log("expo Booth no", this.expoBoothNo);
      console.log("expo Email", this.expoEmail);
      console.log("expo Website", this.expoWebsite);
      console.log("expo Category", this.expoCategory);
      console.log("expo Contact", this.expoMappedContact);
      console.log("expo Profile", this.expoProfile);
      //click function
      var Exhibitors = {};
      Exhibitors = {
        Name: this.expoName,
        Phone: this.expoPhoneNo,
        BoothNo: this.expoBoothNo,
        Email: this.expoEmail,
        Website: this.expoWebsite,
        Category: this.expoCategory,
        MappedContacts: this.expoMappedContact,
        Profile: this.expoProfile,
        ShowcaseVideoURL: this.expoShowcaseVideo,
        HtmlCode: "",
        Logo: "",
        IsPublished: true,
        DisplaySequence: "",
        AriealBoothImgURL: "",
        Resources: "",
        ShowcaseImages: "",
        UserRoles: [
          {
            RoleID: 10,
            RoleName: "AppUser",
          },
          {
            RoleID: 12,
            RoleName: "Exhibitor",
          },
        ],
        SocialLinks: [
          { Facebook: "" },
          { Twitter: "" },
          { GooglePlus: "" },
          { LinkedIn: "" },
        ],
        mappedchatgroup: "",
        RoundTableTopic: "",
        Type: "",
      };

      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
        instanceId: "OA_UAT",
        clientId: this.$store.state.client[0].id,
        eventId: this.$store.state.eventid,
        //"x-api-key": APIs.DeleteAttendeeApiKey,
      };
      let requestData = {
        data: Exhibitors,
      };
      axios
        .post(APIs.ExpoAddDataApi, requestData, { headers: headers })
        .then(function (response) {
          console.log("response====", response);
          if (response.status == 200) {
            bus.$emit("toggleLoader", false);
            this.e6 = 2;
          }
        })
        .catch(function (error) {
          console.log("Error adding attendee:", error);
          //reject(error);
        });
    },
    editexpolist(exhibitor) {
      console.log("Exhibitor", exhibitor);
      (this.expoName = exhibitor.Name),
        (this.expoPhoneNo = exhibitor.Phone),
        (this.expoBoothNo = exhibitor.BoothNo),
        (this.expoEmail = exhibitor.Email),
        (this.expoWebsite = exhibitor.Website),
        (this.expoCategory = exhibitor.Category),
        (this.expoMappedContact = exhibitor.MappedContacts),
        (this.expoProfile = exhibitor.Profile),
        (this.expoShowcaseVideo = exhibitor.ShowcaseVideoURL),
        (this.ExpoBoothAdd = true);
    },
    toExpoList(exhibitorid){
      router.push("/expo-studio/"+exhibitorid);

    },
  },
};
</script>
